import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { Row, Col, Label } from 'react-bootstrap';
import axios from 'axios';
import {
  getInvoicePaymentOptions,
  getInvoicePaymentOptionName,
  INVOICE_PAYMENT_OPTION_INHERITED,
  INVOICE_PAYMENT_OPTION_ENABLED,
} from 'helpers/clients';

import FormAutocomplete from 'components/forms/FormAutocomplete';
import InvoicePaymentThreshold from './InvoicePaymentThreshold';

function InvoicePaymentOption(props) {
  const { inModal, entity, disabled } = props;

  const username = entity.getUsername();
  const currentSetting = entity.getInvoicePaymentOption();

  const {
    setting: storedSetting,
    is_inherited: storedIsInherited,
    inherited_from_name: storedInheritedFromName,
  } = entity.getEffectiveInvoicePaymentOption();

  // when was just set to "INHERITED" and no inherited value info, need to make extra request to API
  const needLookup = currentSetting === INVOICE_PAYMENT_OPTION_INHERITED && storedIsInherited === false;

  const [isPending, setIsPending] = useState(needLookup);
  const [inheritedFrom, setInheritedFrom] = useState(storedInheritedFromName);
  const [inheritedSetting, setInheritedSetting] = useState(storedSetting);

  const isThresholdHasEffect =
    currentSetting === INVOICE_PAYMENT_OPTION_ENABLED ||
    (currentSetting === INVOICE_PAYMENT_OPTION_INHERITED && inheritedSetting === INVOICE_PAYMENT_OPTION_ENABLED);

  const updateEntity = (propertyName, value) => {
    const { entity, changeEntity } = props;
    const newEntity = { ...entity.updateValue(propertyName, value) };
    changeEntity(newEntity);
  };

  useEffect(() => {
    if (!needLookup) return;

    axios
      .get(`/api/clients/${username}/inheritedinvoicepaymentoption.json`)
      .then(response => {
        const { data } = response;
        setInheritedFrom(data.inherited_from_name);
        setInheritedSetting(data.setting);
        setIsPending(false);
      })
      .catch(console.error);
  }, [needLookup, username]);

  const { messages } = useIntl();

  return (
    <Row>
      <Col xs={12} md={12}>
        <div className="panel panel-transparent">
          <div className="panel-body">
            <h4>{messages.invoice_payment_option.title}</h4>
            <div className="form-group-attached">
              <FormAutocomplete
                // label={messages.salutation}
                label="setting"
                name="invoicePaymentOption"
                value={currentSetting}
                meta={entity.getInvoicePaymentOptionMetaInformation()}
                validation={entity.getInvoicePaymentOptionValidationResult()}
                onChange={updateEntity}
                options={getInvoicePaymentOptions(messages)}
                disabled={disabled}
              />
              {currentSetting === INVOICE_PAYMENT_OPTION_INHERITED && (
                <div className="form-group form-group-default form-autocomplete">
                  {isPending ? (
                    <>
                      <i class="fa circle-o-notch fa-spin text-warning" />
                      {messages.invoice_payment_option.loading}
                    </>
                  ) : (
                    <>
                      {messages.invoice_payment_option.effective_setting}{' '}
                      <Label>{getInvoicePaymentOptionName(messages, inheritedSetting)}</Label> via &quot;{inheritedFrom}
                      &quot;
                    </>
                  )}
                </div>
              )}
              <InvoicePaymentThreshold isThresholdHasEffect={isThresholdHasEffect} {...props} />
            </div>
          </div>
        </div>
      </Col>
    </Row>
  );
}

export default InvoicePaymentOption;
